import { ReactNode } from "react";
import z from "zod";

import {
  GetNgpVanIntegrationQuery,
  NgpVanDatabaseModeGqlType,
} from "~frontend/__generated__/graphql";

export type Integration = GetNgpVanIntegrationQuery["getNgpVanIntegration"];

export type BaseProps = {
  label: string;
  error?: boolean;
  helperText?: ReactNode;
  integrationId: string;
  databaseMode: NgpVanDatabaseModeGqlType;
  readOnly?: boolean;
  value: number | null;
};

export const NgpVanActionFieldSchema = z
  .object({
    integrationIdAndDbMode: z.string().min(1, "Required"),
    actionType: z
      .enum([
        "APPLY_ACTIVIST_CODE",
        "APPLY_RESULT_CODE",
        "APPLY_SURVEY_RESPONSE",
        "",
      ])
      // We include "" here to allow for initial empty state before user selection
      // but reject it during validation
      .refine(val => val.length > 0, { message: "Required" }),
    activistCodeId: z.string(),
    resultCodeId: z.string(),
    surveyQuestionId: z.string(),
    surveyResponseId: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.actionType === "APPLY_ACTIVIST_CODE" && !data.activistCodeId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Required",
        path: ["activistCodeId"],
      });
    }

    if (data.actionType === "APPLY_RESULT_CODE" && !data.resultCodeId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Required",
        path: ["resultCodeId"],
      });
    }

    if (data.actionType === "APPLY_SURVEY_RESPONSE") {
      if (!data.surveyQuestionId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Required",
          path: ["surveyQuestionId"],
        });
      }

      if (!data.surveyResponseId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Required",
          path: ["surveyResponseId"],
        });
      }
    }
  });

export type NgpVanActionFieldValues = z.infer<typeof NgpVanActionFieldSchema>;
